import { BASE_URL } from '@helpers/constants'
import setAuthorization from '@helpers/setAuthorization'
import { ListTutorialsResponse } from '@models/tutorial.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const tutorialsAPI = createApi({
	reducerPath: 'tutorialsAPI',
	tagTypes: ['Tutorials'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: (headers, { endpoint, getState }) =>
			setAuthorization(headers, { getState, endpoint }),
	}),
	endpoints: (builder) => ({
		listTutorials: builder.query<ListTutorialsResponse, void>({
			query: () => ({
				url: '/tutorials',
				method: 'GET',
			}),
			providesTags: ['Tutorials'],
		}),
		markTutorialWatched: builder.mutation<void, { tutorialId: number }>({
			query: ({ tutorialId }) => ({
				url: `/tutorials/${tutorialId}/view`,
				method: 'POST',
			}),
			invalidatesTags: ['Tutorials'],
		}),
	}),
})

export const { useListTutorialsQuery, useMarkTutorialWatchedMutation } =
	tutorialsAPI
